import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectListServicedeskRoute: InvariantJiraRoute = {
	name: 'servicedesk-list',
	path: '/jira/servicedesk/projects/:projectKey/list/:navigationItemId?',
};
